import { X } from "lucide-react";
import { toast } from "react-toastify";
import { createPortal } from "react-dom";
import {
  deleteDealWithPhotos,
} from "../../utils/firebasefunctions";
import { useState } from "react";
import DealCard from './deal-card';

const DeleteDeal = ({ onClose, onSubmit, deal , closepopup}) => {

  const [loading, setLoading] = useState(false);

  const handleYes = async () => {
    setLoading(true);
    try {
      const isDeleted = await deleteDealWithPhotos(deal.createdat);

      if (!isDeleted) {
        toast.error("Deal not found or already deleted");
        return;
      }

      toast.success("Deal deleted successfully!");
      onSubmit?.();
      onClose?.();
      closepopup?.();
    } catch (err) {
      console.error("Delete deal failed:", err);
      toast.error("Something went wrong while deleting deal");
    } finally {
      setLoading(false);
    }
  };


  return createPortal(
    <>
      <div
        className="fixed inset-0 bg-black/50 z-[100] transition-opacity"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-[110] flex items-center justify-center p-4 pointer-events-none">
        <div className=" rounded-lg  overflow-hidden shadow-2xl w-[90%] md:w-[50%] lg:w-[65%]  bg-white relative pointer-events-auto">
          {/* Header */}
          <div className="absolute right-3 mt-1">
            <button
              onClick={onClose}
              className="w-9 h-9 bg-white/20 hover:bg-white/30 rounded-full text-lg flex items-center justify-center transition-all hover:rotate-90"
            >
              <X className="w-6 h-6 text-foreground" />
            </button>
          </div>
          <div className="mt-10">
            <p className="text-xl text-center font-semibold">
              Are you sure want to delete this deal?
            </p>
          </div>
          <div className="mx-3 border border-gray-200 rounded-lg mt-5">
            <DealCard
            data={deal}
            viewdetails={false}
            onBgColor={true}
          />
          </div>
          <div className="flex justify-center gap-x-3 mt-6 mb-5">
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="px-6 py-2 text-sm font-semibold rounded-md border border-slate-300 text-slate-700 hover:bg-slate-50 disabled:opacity-50"
            >
              No
            </button>
            <button
              type="button"
              onClick={handleYes}
              disabled={loading}
              className="px-6 py-2 text-sm font-semibold rounded-md bg-red-600 hover:bg-red-700 text-white disabled:opacity-50 inline-flex items-center gap-2"
            >
              {loading && (
                <svg
                  className="w-4 h-4 animate-spin"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                  />
                </svg>
              )}
              {loading ? "Deleting…" : "Yes, delete"}
            </button>
          </div>
        </div>
      </div>
    </>,
    document.body,
  );
};

export default DeleteDeal;
